/**
 * @imports
 */
import { fnPeriodosRentaQuery } from './fnPeriodosRentaQuery';
import { solPagoServicioQuery } from './solPagoServicioQuery';

/**
 *
 * @returns
 */
export function fnComPdaEquipoSuministradoQuery() {
  return {
    as: 'equipoSuministrado',
    required: false,
    attributes: [
      'iId',
      ['sStatusValidacion', 'status'],
      ['sNumeroEconomico', 'economico'],
      ['sDescripcion', 'descripcion'],
      ['dInicioArrendamiento', 'inicio'],
      ['dTerminoArrendamiento', 'termino'],
    ],

    include: [{
      ...fnPeriodosRentaQuery(solPagoServicioQuery),
      as: 'periodosRenta',
      required: false,
      model: null,
    }],

    where: {
      iActivo: true,
    }
  };
}
